export class AtividadeFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getAtividades(filter) {
    return this.instance.get('/v1/cat-atividades', {
      params: filter || null,
    });
  }

  getAtividade(id) {
    return this.instance.get(`/v1/cat-atividades/${id}`);
  }

  addAtividade(data) {
    return this.instance.post('/v1/cat-atividades', data);
  }

  editAtividade(id, data) {
    return this.instance.put(`/v1/cat-atividades/${id}`, data);
  }

  deleteAtividade(id, activityToMove) {
    return this.instance.delete(
      `/v1/cat-atividades/${id}?activity_to_move=${activityToMove}`,
    );
  }

  getAtividadeMetas(atividadeId, filter) {
    return this.instance.get(`/v1/cat-atividades/${atividadeId}/metas/`, {
      params: filter || null,
    });
  }

  getAtividadeMeta(atividadeId, id) {
    return this.instance.get(`/v1/cat-atividades/${atividadeId}/metas/${id}`);
  }

  addAtividadeMeta(atividadeId, data) {
    return this.instance.post(`/v1/cat-atividades/${atividadeId}/metas/`, data);
  }

  editAtividadeMeta(atividadeId, id, data) {
    return this.instance.put(
      `/v1/cat-atividades/${atividadeId}/metas/${id}`,
      data,
    );
  }

  deleteAtividadeMeta(atividadeId, id) {
    return this.instance.delete(
      `/v1/cat-atividades/${atividadeId}/metas/${id}`,
    );
  }

  archiveAtividades(data) {
    return this.instance.post('/v1/cat-atividades/arquivados', data);
  }

  unarchiveAtividades(data) {
    return this.instance.post('/v1/cat-atividades/desarquivados', data);
  }
}
export default (...params) => new AtividadeFactory(...params);
